import columns from '../../../../../react-table/helpers/columns';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';

export function getDetailsTabNavOptions(rowInfo) {
  return rowInfo && rowInfo.row ? {
    reportId: ReportDefinitions.PREDES_RESDES_DESPATCHES_DETAILS.id,
    mainReportId: ReportDefinitions.PREDES_RESDES_DESPATCHES_SUMMARY.id,
    requestParams: {
      despatchId: rowInfo.row['predes.despatchId'],
    },
    selectionCriteriaOptions: {
      includeSelectionCriteria: true,
    },
  } : {};
}

export default (data) => {
  const {
    TextColumn,
    DateColumn,
    DurationColumn,
    NonZeroPercentageColumn,
    NonZeroNumberColumn,
    NavigationColumn,
    ExternalDespatchLinkColumn,
  } = columns(data);

  return [
    {
      Header: 'PREDES',
      columns: [
        new ExternalDespatchLinkColumn(new TextColumn('Despatch ID', 'predes.despatchId')
          .withWidth(210)),
        new TextColumn('Origin IMPC', 'predes.originImpc'),
        new TextColumn('Destination IMPC', 'predes.destinationImpc'),
        new TextColumn('Mail category', 'predes.mailCategory'),
        new TextColumn('Mail subclass', 'predes.mailSubclass'),
      ],
    },
    {
      Header: 'Despatch closed',
      columns: [
        new TextColumn('Day', 'despatchCloseDate.weekDay'),
        new DateColumn('Date', 'despatchCloseDate.date'),
        new DurationColumn('Time', 'despatchCloseDate.time'),
      ],
    },
    {
      Header: 'RESDES',
      columns: [
        new DateColumn('First scan date', 'resdes.firstScanDate'),
        new DurationColumn('First scan time', 'resdes.firstScanTime'),
        new DateColumn('Last scan date', 'resdes.lastScanDate'),
        new DurationColumn('Last scan time', 'resdes.lastScanTime'),
      ],
    },
    {
      Header: 'Receptacles',
      columns: [
        new NavigationColumn(new NonZeroNumberColumn('PREDES', 'receptacles.predes'), getDetailsTabNavOptions),
        new NavigationColumn(new NonZeroNumberColumn('RESDES', 'receptacles.resdes'), getDetailsTabNavOptions),
        new NonZeroPercentageColumn('% responded', 'receptacles.respondedPercentage'),
      ],
    },
    {
      Header: 'Differences',
      columns: [
        new NonZeroNumberColumn('Receptacle type', 'differences.receptacleType'),
        new NonZeroNumberColumn('Mail class', 'differences.mailClass'),
        new NonZeroNumberColumn('Documents included', 'differences.documentsIncluded'),
        new NonZeroNumberColumn('Dangerous goods', 'differences.dangerousGoods'),
        new NonZeroNumberColumn('Format of contents', 'differences.formatOfContents'),
        new NonZeroNumberColumn('Handling class', 'differences.handlingClass'),
        new NonZeroNumberColumn('Express', 'differences.express'),
        new NonZeroNumberColumn('Exempt', 'differences.exempt'),
        new NonZeroNumberColumn('Weight', 'differences.weight'),
        new NonZeroNumberColumn('Weight type', 'differences.weightType'),
        new NonZeroNumberColumn('Items', 'differences.items'),
        new NonZeroNumberColumn('Non- returned', 'differences.nonReturned'),
        new NonZeroNumberColumn('Returned', 'differences.returned'),
      ],
    },
  ];
};
